export default function translateTabType(label) {
  if (label == "Voor wie zoekt u subsidies?")
    return "For who are you searching?";
  else if (label == "Locatie") return "Location";
  else if (label == "Onderwerp") return "Subject";
  else if (label == "Type Bijdrage") return "Type of support";
}
